import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AsyncPipe } from '@angular/common';
import { ModalConfirmService } from '@core/services/modal-confirm.service';
import { ModalConfirmConfig } from '@core/interfaces/modal-confirm';
import { ButtonComponent } from '@shared/components/form/button/button.component';

@Component({
    selector: 'app-modal-confirm',
    imports: [
        AsyncPipe,
        ButtonComponent
    ],
    templateUrl: './modal-confirm.component.html',
    styleUrl: './modal-confirm.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalConfirmComponent {
  private readonly modalConfirmService = inject(ModalConfirmService);
  readonly isOpen$ = this.modalConfirmService.isOpen$;
  readonly config = toSignal(this.modalConfirmService.config$, {
    initialValue: null as ModalConfirmConfig | null,
  });

  close() {
    this.modalConfirmService.close();
  }

  confirm() {
    this.modalConfirmService.confirm();
  }

  get modalSizeClasses(): string {
    const width = this.config()?.width || 'sm';

    const widthClassMap: Record<string, string> = {
      sm: 'max-w-sm',
      md: 'max-w-md',
      lg: 'max-w-lg',
      xl: 'max-w-xl',
      full: 'w-full',
    };

    return widthClassMap[width] || 'max-w-sm';
  }
}
